// frontend/src/pages/BookReader.jsx
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import MainLayout from '../../layouts/MainLayout';
import './styles/EBooks.css';
import './styles/bookListComponent.css';

const BookReader = () => {
  const { bookId } = useParams();
  const [book, setBook] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBookData = async () => {
      try {    
        const response = await axios.get(`http://localhost:3030/books/${bookId}`);
        setBook(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching book data:', error);
        setLoading(false);
      }
    };

    fetchBookData();
  }, [bookId]); 

  return (
    <MainLayout>
      <div>
        <h3 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Book Reading</h3>
      </div>
      <div className='bookread-page-container'>
        {loading ? (
          <p className="loading">Loading...</p>
        ) : (
          <div>
            <div dangerouslySetInnerHTML={{ __html: book?.content }} />
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default BookReader;




// return (
//   <MainLayout>
//     <div>
//       <h3 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Book Reading</h3>
//     </div>
//     <div className='bookread-page-container'>
//       {loading ? (
//         <p className="loading">Loading...</p>
//       ) : (
//         <>
//           {book.map((bookItem, index) => (
//             <div key={index}>
//               <h1>{bookItem.title}</h1>
//               {/* Rendering HTML content safely */}
//               <div dangerouslySetInnerHTML={{ __html: bookItem.content }} />
//               <div className="bookread-button-container">
//                 <BookReaderPreviousPage onClick={prevPage} disabled={currentPage === 1} />
//                 <p>{bookItem.pageNumber[currentPage - 1]}</p>
//                 <BookReaderNextPage onClick={nextPage} disabled={currentPage === book.totalPages} />
//               </div>
//             </div>
//           ))}
//         </>
//       )}
//     </div>
//   </MainLayout>
// );